import type { CheckoutSubMode } from './checkoutApi.js';

const CHECKOUT_MODES: readonly CheckoutSubMode[] = [
  'PAY_NOW_SELF_SERVICE',
  'PAY_NOW_STAFF_HANDOFF',
  'PREPAY_COLLECT_LATER',
];

function storageKey(tenantCode: string, kioskId: number): string {
  return `customer_checkout_mode:${tenantCode}:${kioskId}`;
}

function isCheckoutSubMode(value: string): value is CheckoutSubMode {
  return (CHECKOUT_MODES as readonly string[]).includes(value);
}

export function readLastCheckoutMode(
  tenantCode: string,
  kioskId: number | null | undefined
): CheckoutSubMode | null {
  if (kioskId === null || kioskId === undefined || kioskId <= 0) {
    return null;
  }
  try {
    const raw = window.sessionStorage.getItem(storageKey(tenantCode, kioskId));
    if (raw !== null && isCheckoutSubMode(raw)) {
      return raw;
    }
  } catch {
    return null;
  }
  return null;
}

export function rememberCheckoutMode(
  tenantCode: string,
  kioskId: number,
  mode: CheckoutSubMode
): void {
  try {
    window.sessionStorage.setItem(storageKey(tenantCode, kioskId), mode);
  } catch {
    // sessionStorage may be unavailable
  }
}
